import cache from '../src/js/cache';
import {lastClickEl} from '../src/js/const';
import siblingFadeTransition from './sibling-fade-transition';
import categoryToCategory from './category-to-category';
import fadeTransition from './fade-transition';
import qs from 'query-string';
/*
|
|--------------------------------------------------------------------------
| Page Transitions
|--------------------------------------------------------------------------
| This controls what Barba.js transition to based on three factors
| 1: Does the link clicked have the attribute page-transition
| 2: If not, see if there is a transition for the name space
| 3: If neither correspond default to a transition
|
*/

const defaultTransition =  Barba.Pjax.getTransition(); // Store Default Transition here to use later
Barba.Pjax.getTransition = function() {
    const lastClickElement = cache.get(lastClickEl);
    if (!lastClickElement) {
        return defaultTransition;
    }

    const pageTransition = cache.get(lastClickEl).getAttribute('barba-transition');
    const prevNamespace = Barba.HistoryManager.prevStatus().namespace ;
    const currentStatus = Barba.HistoryManager.currentStatus();
    const { url: currentUrl } = qs.parseUrl(currentStatus.url);  // Has to use url since currentStatus namespace is always undefined

//|--------------------------------------------------------------------------
//| Check page transition based on link clicked
//|--------------------------------------------------------------------------
    if (pageTransition === 'sibling-fade') {
        return siblingFadeTransition;
    }

    if (pageTransition === 'category-to-category') {
        return categoryToCategory;
    }

    if (prevNamespace === 'design-center' && currentUrl.endsWith('/design-center/')) {
        return fadeTransition;
    }

//|--------------------------------------------------------------------------
//| If all fails default to transition
//|--------------------------------------------------------------------------
    return defaultTransition;
};